import { handleRequest } from '@/utils';
import { addDialogue, updateDialogueInfo } from '@/utils/sessionUtils';
import { Intent } from '@/types/intent';

type HandleRequestCB = (res: any) => void;

const handleClickIntentUseMessage = async (content: string, intent: Intent, cb?: HandleRequestCB) => {
  const curPos = addDialogue({
    from: 'user',
    type: 'Msg',
    data: { content: content },
  });


  if (typeof curPos === 'number') {
    const params = { ...intent, text: content };

    handleRequest('postMessage', params, { curPos }).then((res: any) => {
      res && updateDialogueInfo({
        dialogueId: res.dialogue_id,
        dialogueType: res.dialogue_type,
      }, curPos);

      cb && cb(res);
    });
  }
};

export default handleClickIntentUseMessage;
